var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBb04C(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 52,
    height: 42,
    viewBox: "0 0 52 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.486 3.99722L47.7749 5.25358C40.4436 8.11241 34.8963 13.0225 29.8048 18.8299C28.034 20.8426 26.3932 22.9707 24.5962 24.9577C23.0856 26.6372 21.3798 28.4833 19.2182 29.2909C19.036 29.2653 18.489 28.3166 18.3848 28.1243C16.6268 24.5476 18.0333 17.5991 14.7127 15.1377C14.0616 14.6505 13.2803 14.3814 12.486 14.2275C13.8012 12.1763 15.8456 11.1379 18.1635 12.4712C20.1819 13.6378 21.497 16.3172 21.7835 18.5478L21.8746 20.6631C24.1795 17.2402 27.0182 14.1506 30.2216 11.5225C36.0553 6.74068 43.699 3.09983 51.486 4.01003V3.99722Z",
    fill: "url(#paint0_linear_0_59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.8687 5.28831C32.3028 5.88983 31.2103 6.94246 30.5784 7.46879C30.4599 7.56905 30.1176 7.84474 30.0123 7.88233C29.5648 8.07031 27.9983 7.61917 27.4455 7.46879C24.6154 6.74197 22.0223 5.52641 19.3369 4.43617C16.1119 5.92742 12.9132 7.21815 9.37228 7.9074C7.91114 8.19562 6.29206 8.28334 4.87042 8.60917C4.75195 8.63422 4.46235 8.69688 4.38338 8.75954C4.01481 9.01017 4.3044 10.7019 4.31756 11.1656C4.43603 14.1732 4.44919 17.2184 5.16001 20.1507C6.60797 26.1282 9.68819 31.1284 14.6507 35.0507C15.3878 35.6272 18.2575 37.6071 19.0473 37.7575C19.837 37.9079 21.7194 36.6924 22.4302 36.2162C27.7614 32.6822 31.3944 27.5317 33.3032 21.6419L37.2916 17.8198L37.8182 17.7321C37.5417 20.226 36.8046 22.8325 35.87 25.1633C33.4084 31.2285 28.5775 36.6171 22.9436 40.2263C22.246 40.6773 20.39 41.8303 19.6396 41.9807C19.0341 42.1059 18.1128 41.5921 17.573 41.3164C12.4393 38.6347 7.35829 33.359 4.58082 28.4841C0.908269 22.0555 0.223775 15.5641 0.0263259 8.346C0.0131625 7.83221 -0.0526525 5.95247 0.0921439 5.6016C0.157961 5.45121 0.408063 5.3635 0.566024 5.31336C7.22666 4.66173 13.4529 2.83212 19.4027 0C23.7729 1.90479 28.1957 3.78453 32.9872 4.51135C33.4875 4.67426 33.0399 5.05021 32.8425 5.27577L32.8687 5.28831Z",
    fill: "url(#paint1_linear_0_59)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_59",
    x1: 12.486,
    y1: 16.5735,
    x2: 51.486,
    y2: 16.5735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#02BEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0A90FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#106EFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#135AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1553FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_59",
    x1: 0.0263266,
    y1: 21.0153,
    x2: 37.8576,
    y2: 21.0153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#02BEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0A90FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#106EFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#135AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1553FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb04C);
export default __webpack_public_path__ + "static/media/bb04c.654dc6ada1478cd98abd1adfa4b505e7.svg";
export { ForwardRef as ReactComponent };